import React from 'react';
import { createComponentBase, BaseComponentProps } from "../../../libs/components";

export interface ScrollingTextProps extends BaseComponentProps {
    children?: string;
}

export const ScrollingText = ({
    children,
    className,
}: ScrollingTextProps) => {
    const componentClassName = 'm-scrollingText';
    const modifiers = {
        "height": !!children
    };
    const { Container }: { Container: React.ElementType } = createComponentBase(componentClassName, 'div');

    return (
        <Container className={className} modifiers={modifiers}>
            <div className={`${componentClassName}__container`}>
                {/* Wrapping the text twice for infinite scrolling effect */}
                <span className={`${componentClassName}__text`}>
                    <p dangerouslySetInnerHTML={{ __html: children as string }} />
                </span>
                <span className={`${componentClassName}__text`}>
                    <p dangerouslySetInnerHTML={{ __html: children as string }} />
                </span>
            </div>
        </Container>
    );
};
